import { Helmet } from "react-helmet-async";

export default function SEO({
  title = "Pennsylvania Accident Aid | Free 24/7 Help for Accident Victims",
  description = "Injured in Pennsylvania? Get a free, no-obligation case review with experienced local attorneys. Available 24/7. No fees unless you win.",
  image,
  imageAlt,
  url,
  canonical,
  type = "website",
  schema,
}) {
  const fullTitle = title.includes("Pennsylvania Accident Aid") ? title : `${title} | Pennsylvania Accident Aid`;
  // Self-referencing canonical: explicit `canonical` wins, else `url`, else the
  // current location with query/hash stripped. Prevents duplicate-content issues.
  const rawCanonical =
    canonical ||
    url ||
    (typeof window !== "undefined" ? window.location.origin + window.location.pathname : undefined);
  const canonicalHref = rawCanonical ? rawCanonical.split("?")[0].split("#")[0] : undefined;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonicalHref && <link rel="canonical" href={canonicalHref} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Pennsylvania Accident Aid" />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      {image && imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {image && imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
